import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import SharedButton from '../global/Button/Button';
import { useNavigate } from 'react-router-dom';

// Extend Window interface for LinkedIn tracking
declare global {
  interface Window {
    _linkedin_data_partner_ids?: string[];
    lintrk?: {
      (action: string, data?: any): void;
      q?: any[];
    };
  }
}

function ThankYouPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const _linkedin_partner_id = '8934697';
    (window as any)._linkedin_data_partner_ids = (window as any)._linkedin_data_partner_ids || [];
    (window as any)._linkedin_data_partner_ids.push(_linkedin_partner_id);

    (function (l: any) {
      if (!l) {
        (window as any).lintrk = function (a: any, b: any) {
          (window as any).lintrk.q.push([a, b]);
        };
        (window as any).lintrk.q = [];
      }
      const s = document.getElementsByTagName('script')[0];
      const b = document.createElement('script');
      b.type = 'text/javascript';
      b.async = true;
      b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
      s.parentNode?.insertBefore(b, s);
    })((window as any).lintrk);

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://snap.licdn.com/li.lms-analytics/insight.min.js"]',
      );
      scripts.forEach(script => script.remove());
    };
  }, []);

  return (
    <div>
      <Helmet>
        <title>DISGENET: Thank You</title>
        <meta name="description" content="Thank you for booking a demo with DISGENET." />
      </Helmet>
      <div className="notFoundPage" style={{ height: '60vh' }}>
        <h2>Thank you for booking a demo</h2>
        <p>We&lsquo;ll be in touch soon!</p>
        <SharedButton
          id="brochure"
          size="xs"
          onClick={e => {
            e.preventDefault();
            navigate('/brochure');
          }}
          type="button"
          className="btn-gradient-pink mx-0 mb-2 px-4"
          style={{
            height: '40px',
            fontSize: '15px',
            textAlign: 'center',
            display: 'inline-block',
          }}
        >
          Learn more about DISGENET
        </SharedButton>
      </div>
      {/* LinkedIn Insight Tag noscript fallback */}
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: 'none' }}
          alt=""
          src="https://px.ads.linkedin.com/collect/?pid=8934697&fmt=gif"
        />
      </noscript>
    </div>
  );
}

export default ThankYouPage;
